// V4-DL (spec-v4-downloads.md): the one Download control, dropped into each place a file can be saved. It's a plain
// <a href={downloadUrl} download>: the API's link is same-origin and answers with Content-Disposition: attachment and
// the right file name, so the browser saves the original file (no re-encoding, no zip). Renders nothing without a link.
//   variant "icon"   a round icon button (rows, toolbars)
//   variant "button" a quiet small button with the word Download
//   variant "item"   a row for a menu or list (label + hint)
import { canDownload } from "../download";
import { Icon } from "./bits";

export type DownloadProps = {
  url: string | null | undefined;
  /** the file name the link saves as (server-picked; shown in the label, used as the download hint) */
  name?: string | null;
  /** what it is, for screen readers and the item label: "Scene 3 frame" */
  label?: string;
  variant?: "icon" | "button" | "item";
  hint?: string;
  className?: string;
};

export function Download({ url, name, label, variant = "icon", hint, className = "" }: DownloadProps) {
  if (!canDownload(url)) return null;
  const what = label || name || "this file";
  const common = { href: url, download: name || "", "data-action": "download", rel: "noopener" } as const;
  if (variant === "item")
    return (
      <a {...common} className={`more-item dl-item ${className}`} role="menuitem">
        <Icon name="download" size={18} />
        <span>
          <span className="more-item-label">{label ?? "Download"}</span>
          {hint && <span className="more-item-hint">{hint}</span>}
        </span>
      </a>
    );
  if (variant === "button")
    return (
      <a {...common} className={`btn btn-quiet btn-small ${className}`} aria-label={`Download ${what}`}>
        <Icon name="download" size={14} /> Download
      </a>
    );
  return (
    <a {...common} className={`icon-btn ${className}`} aria-label={`Download ${what}`} title="Download">
      <Icon name="download" size={18} />
    </a>
  );
}
